import { CurrencyInput } from '@/components/currency-input'
import { useSimpleCalculator } from '@/hooks/use-simple-calculator'
import { toCurrency } from '@/utils/money'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useContext, useEffect } from 'react'
import { NewContractContext } from './context'

export const ContractAmountsForm = () => {
  const { currentContract } = useContext(NewContractContext)
  const { values, setFieldValue } = useFormikContext()
  const { amounts, handleNetAmount } = useSimpleCalculator({
    defaultTotalAmountCents: currentContract.totalAmountCents || 0
  })

  const { totalAmountCents, ivaAmountCents, netAmountCents } = amounts

  useEffect(() => {
    if (totalAmountCents < 1) return

    setFieldValue('total_amount_cents', totalAmountCents)
  }, [totalAmountCents])

  return (
    <>
      <CurrencyInput
        label="Monto acordado neto"
        defaultValue={netAmountCents}
        onChangeValue={(_, value) => handleNetAmount(value)}
      />

      <Input
        label="IVA"
        readOnly
        value={toCurrency(ivaAmountCents)}
      />

      <Input
        label="Monto acordado total"
        readOnly
        name="total_amount_cents"
        value={toCurrency(values.total_amount_cents)}
      />
    </>
  )
}
